import {ClientProjectDetailState} from "../store/client_project_state";
import {Reducer} from "redux";
import {
    ClientProjectDetailAction,
    ClientProjectDetailActionType,
    ICallbackGetProjectDetailAction,
    ICallbackUpdateProjectDetailAction,
    ICallbackCreateProjectDetailAction,
} from "../action/client_project_action";

const initialState: ClientProjectDetailState = {
    project: null,
    company: null,
    isLoading: false,
};

const clientProjectDetailReducer: Reducer<ClientProjectDetailState> = (state = initialState, action: ClientProjectDetailAction): ClientProjectDetailState => {
    switch (action.type) {

        case ClientProjectDetailActionType.REQUEST_GET_PROJECT: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientProjectDetailActionType.CALLBACK_GET_PROJECT: {
            const _action = action as ICallbackGetProjectDetailAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    project: (_action.item) ? _action.item.project : null,
                    company: (_action.item) ? _action.item.company : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientProjectDetailActionType.REQUEST_CREATE_PROJECT: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientProjectDetailActionType.CALLBACK_CREATE_PROJECT: {
            const _action = action as ICallbackCreateProjectDetailAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    project: (_action.item) ? _action.item.project : null,
                    company: (_action.item) ? _action.item.company : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientProjectDetailActionType.CALLBACK_UPDATE_PROJECT: {
            const _action = action as ICallbackUpdateProjectDetailAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    project: (_action.item) ? _action.item.project : null,
                    company: state.company,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientProjectDetailActionType.CALLBACK_DRAFT_PROJECT: {
            if (action.isSuccess) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientProjectDetailActionType.CALLBACK_OPEN_PROJECT: {
            if (action.isSuccess) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientProjectDetailActionType.CALLBACK_CLOSE_PROJECT: {
            if (action.isSuccess) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientProjectDetailReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_project_reducer.ts